import React, { useState } from 'react'
import SelectBoxField from '../../shared/components/formfields/SelectBoxField'
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import CustomPagination from '../../shared/utils/CustomPagination';
import { Box, Tooltip, Typography } from '@mui/material';
import CustomDivider from '../../shared/utils/CustomDivider';
import EditIcon from '@mui/icons-material/Edit';
import useContactPersonStore from '../../store/useContactPersonStore';
import useContactPersonListStore from '../../store/userContactPersonListStore';
import DeleteIcon from '@mui/icons-material/Delete';

const ContactPersonTable = ({ isLoading = false }) => {
    const {
        contactpersonList,
        removeContactpersonByIndex
    } = useContactPersonListStore();
    const updatedcontactpersonList = contactpersonList.map((person, index) => ({
        ...person,
        sr_no: index + 1,
        id: index + 1,
    }));


    // const [contactPersons, setContactPersons] = useState([]);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 5 });
    // const ContactPerOption = contactPersons?.map((item, index) => ({
    //     id: item?.id || index + 1,
    //     sr_no: index + 1,
    //     ...item
    // })) || [];

    // const handleChangeApartment = (id) => {
    //     const selectedApartment = apartmentRows.find((item) => item?.id === id);
    //     if (selectedApartment) {
    //         setContactPersons(selectedApartment.contact_persons || []);
    //     } else {
    //         setContactPersons([]);
    //     }

    // };
    const contactPersonColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "mobile_no",
            headerName: "Mobile No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "designation",
            headerName: "Designation",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "actions",
            type: "actions",
            headerName: "Actions",
            flex: 1,
            cellClassName: "actions",
            renderCell: (params) => (
                <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <Tooltip title="Remove">
                        <GridActionsCellItem
                            key={0}
                            icon={<DeleteIcon />}
                            label="Remove"
                            onClick={() => {
                                removeContactpersonByIndex(params?.row?.id-1)
                            }}
                        />
                    </Tooltip>
                </Box>
            ),
        }

    ];

    return (
        <>


            {/* <Box
                width={"40%"}
            >
                <SelectBoxField
                    label="Apartment Name"
                    options={apartmentOption}
                    isRequired={true}
                    onChange={handleChangeApartment}
                    //   ClearFunc={handleClearApartment}
                    isloading={isLoading}
                />
            </Box>
            <CustomDivider /> */}

            {isLoading ? (
                <DataGridSkeleton rowsNum={10} />
            ) : (
                <DataGrid
                    rows={updatedcontactpersonList}
                    columns={contactPersonColumns}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10]}
                    disableRowSelectionOnClick={true}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                totalRows={updatedcontactpersonList?.length || 0}
                                pageSize={paginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}

        </>
    )
}

export default ContactPersonTable